<script>
import HtmlParser from "./html-parser";
import FormParser from "./form-parser";
import ComponentParser from "./component-parser";

export default {
  name: "CmsContainer",
  components: { HtmlParser, FormParser, ComponentParser },
  props: {
    contents: {
      type: Array,
      required: false,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      accordionButtons: []
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.toggleAccordionButtons();
    });
  },
  methods: {
    handleAccordionItem(evt) {
      const button = evt.target;
      const container = button.parentNode.parentNode;
      const iconUp = button.querySelector(".c-accordion-item__icon-up");
      const iconDown = button.querySelector(".c-accordion-item__icon-down");
      const content = container.querySelector(".c-accordion-item__content");
      if (!content) {
        return;
      }
      if (!content.style.display || content.style.display === "none") {
        content.style.display = "block";
        button.setAttribute("aria-hidden", false);
        button.classList.add("u-color-primary-light");
        iconUp.style.display = "block";
        iconDown.style.display = "none";
        iconUp.classList.add("c-icon--primary-light");
      } else {
        content.style.display = "none";
        button.setAttribute("aria-hidden", true);
        button.classList.remove("u-color-primary-light");
        iconDown.style.display = "block";
        iconUp.style.display = "none";
        iconUp.classList.remove("c-icon--primary-light");
      }
    },
    toggleAccordionButtons() {
      this.accordionButtons = this.$el.getElementsByClassName(
        "c-accordion-item__title"
      );
      for (let i = 0; i < this.accordionButtons.length; i++) {
        this.accordionButtons[i].addEventListener(
          "click",
          this.handleAccordionItem,
          false
        );
      }
    },
    destroyListeners() {
      for (let i = 0; i < this.accordionButtons.length; i++) {
        this.accordionButtons[i].removeEventListener(
          "click",
          this.handleAccordionItem,
          false
        );
      }
      this.accordionButtons = [];
    }
  },
  beforeUnmount() {
    this.destroyListeners();
  },
  watch: {
    contents() {
      this.destroyListeners();
      this.$nextTick(() => {
        this.toggleAccordionButtons();
      });
    }
  }
};
</script>

<template>
  <div class="c-cms-container">
    <div
      v-for="(content, index) in contents"
      :key="`cms-content-${index}`"
    >
      <HtmlParser
        v-if="content.type === 'html'"
        :content="content.value"
        :cms-content="true"
        class="c-cms-container__content"
      />
      <FormParser
        v-else-if="content.type === 'form'"
        :form-name="content.value"
        class="c-cms-container__content"
      />
      <ComponentParser
        v-else-if="content.type === 'composant'"
        :component-name="content.value"
        class="c-cms-container__content"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "@/assets/styles/globals/cms.scss";
</style>
